module.exports = __webpack_public_path__ + "static/media/img34.8661a9fa.jpg";